import React from 'react';
import { Reveal } from './Reveal';
export function MaterialsSection() {
  return <section className="w-full sm:pb-24 bg-[#F5EFE8] pb-[27px]" data-id="element-235" data-mp="r87l77su9p5f">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center px-5 sm:px-8 pl-[5px]" data-id="element-236" data-mp="r8hep5d3eefv">
        
        {/* Sin gastar de más Box */}
        <Reveal className="w-full" data-id="element-237" data-mp="116wwghq8cbcp">
          <div className="relative mt-8 rounded-[24px] border-[1.5px] border-[#F27B35]/80 bg-gradient-to-br from-[#FFFDF9] to-[#FFF0E0] p-5 shadow-sm sm:p-8 sm:pt-12 pt-[21px] pb-[4px] pl-[6px] pr-[8px] w-[368px] h-[253px]" style={{
          paddingBottom: "13px",
          width: "373px",
          height: "236px"
        }} data-id="element-238" data-mp="117yjzlofmqbb">
            
            {/* Decorative Diamonds */}
            <div className="absolute -left-2.5 -top-2.5 h-5 w-5 rotate-45 rounded-[3px] bg-[#FFD147]" aria-hidden="true" style={{
            width: "37px",
            height: "37px"
          }} data-id="element-239" data-mp="1jwvcbk09r8qw" />
            <div className="absolute -bottom-2.5 -right-2.5 h-5 w-5 rotate-45 rounded-[3px] bg-[#FFD147]" aria-hidden="true" style={{
            width: "43px",
            height: "43px"
          }} data-id="element-240" data-mp="1otva77myt56x" />

            {/* Top Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-[#1C3587] px-5 py-1.5 font-display text-[11px] font-black uppercase tracking-widest text-white shadow-md whitespace-nowrap" data-id="element-241" data-mp="19anlnr1aukho">
              ¡SIN GASTAR DE MÁS!
            </div>
            
            <div className="flex flex-row items-start gap-4 sm:gap-6" data-id="element-242" data-mp="vf1ylpemmarw">
              {/* Icon */}
              <div className="flex-none" data-id="element-243" data-mp="1s2q5fb98mgw5">
                <span className="flex rounded-[18px] bg-white text-[32px] shadow-[0_8px_24px_rgba(242,123,53,0.15)] w-[51px] h-[42px] items-center justify-center" data-id="element-244" data-mp="1n4onwurgmpms">
                  📦
                </span>
              </div>
              
              {/* Text Content */}
              <div className="flex-1 text-left" data-id="element-245" data-mp="1eaa8ms6xjf3o">
                <h2 className="font-display text-[10px] font-black uppercase tracking-[0.15em] text-[#1C3587]" data-id="element-246" data-mp="2av122ndatilt">
                  EMPEZÁ HOY MISMO
                </h2>
                
                <h3 className="mt-1.5 font-display text-[22px] font-black leading-[1.1] text-[#F27B35] sm:text-3xl w-[249px]" data-id="element-247" data-mp="45gy2clg52mh">
                  Convertí materiales reciclados en increíbles inventos.
                </h3>
                
                <p className="mt-2.5 text-[14px] font-bold leading-snug text-[#4A5568] sm:text-base w-[250px] h-[55px]" data-id="element-248" data-mp="3qks63ekgk5gl">
                  Cajas, cartón, botellas, tapitas y tubos se transforman en proyectos creativos para aprender jugando.
                </p>
              </div>
            </div>

            {/* Materials Badges */}
            <div className="mt-6 flex w-full justify-between gap-2" style={{
            width: "355px",
            height: "32px"
          }} data-id="element-249" data-mp="37mh1v18ber4f">
              <div className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-100 bg-[#F8FAFC] py-2.5 shadow-sm h-[39px]" data-id="element-250" data-mp="3cl0q58adsezy">
                <span aria-hidden="true" className="text-sm" data-id="element-251" data-mp="15sztfvcd1m8m">📦</span>
                <span className="font-display text-[11px] font-black text-[#1C3587]" data-id="element-252" data-mp="1asw1q6s3bztz">Cajas</span>
              </div>
              <div className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-100 bg-[#F0FDF4] py-2.5 shadow-sm" data-id="element-253" data-mp="2vchmbsjk6ljm">
                <span aria-hidden="true" className="text-sm" data-id="element-254" data-mp="351rgrf1vkgaw">🧴</span>
                <span className="font-display text-[11px] font-black text-[#1C3587]" data-id="element-255" data-mp="35441u12xj6s6">Botellas</span>
              </div>
              <div className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-100 bg-[#FFFBEB] py-2.5 shadow-sm" data-id="element-256" data-mp="3e2pmq2vvixw4">
                <span aria-hidden="true" className="text-sm" data-id="element-257" data-mp="3a0cg7c9ayvya">📄</span>
                <span className="font-display text-[11px] font-black text-[#1C3587]" data-id="element-258" data-mp="3o1f31r84gaa9">Tubos</span>
              </div>
              <div className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-100 bg-[#EFF6FF] py-2.5 shadow-sm" data-id="element-259" data-mp="3j2u21pl1pmkr">
                <span aria-hidden="true" className="text-sm" data-id="element-260" data-mp="1toyrcawk43y0">🔵</span>
                <span className="font-display text-[11px] font-black text-[#1C3587]" data-id="element-261" data-mp="1opcbdtpcg9li">Tapitas</span>
              </div>
            </div>
          </div>
        </Reveal>

        {/* 4 Quick Benefits */}
        <Reveal className="mt-4 w-full" delay={0.2} data-id="element-262" data-mp="1v2gj38hgmaae">
          <div className="grid grid-cols-4 gap-1.5 sm:gap-4" data-id="element-263" data-mp="203e2foe7hadh">
            
            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 text-center shadow-sm sm:p-4" data-id="element-264" data-mp="2019yx7k7yddq">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F1F5FB] text-lg sm:h-12 sm:w-12 sm:text-2xl" aria-hidden="true" data-id="element-265" data-mp="17frxoct8rzp1">
                📹
              </span>
              <div data-id="element-266" data-mp="1hblg2ctn6neq">
                <h4 className="font-display text-[9px] font-black leading-tight text-[#1C3587] sm:text-[12px]" data-id="element-267" data-mp="1hbbrmto8wob5">
                  Videos fáciles
                </h4>
                <p className="mt-0.5 text-[7px] font-bold leading-tight text-gray-500 sm:text-[9px]" data-id="element-268" data-mp="ooqzvs3uya72">
                  Explicados paso a paso
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 text-center shadow-sm sm:p-4" data-id="element-269" data-mp="36xlhuveu34ty">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F1F5FB] text-lg sm:h-12 sm:w-12 sm:text-2xl" aria-hidden="true" data-id="element-270" data-mp="32tvzwosnzlhw">
                🧩
              </span>
              <div data-id="element-271" data-mp="2szwyjs0f05r0">
                <h4 className="font-display text-[9px] font-black leading-tight text-[#1C3587] sm:text-[12px]" data-id="element-272" data-mp="2ny7oael0nw3z">
                  Proyectos creativos
                </h4>
                <p className="mt-0.5 text-[7px] font-bold leading-tight text-gray-500 sm:text-[9px]" data-id="element-273" data-mp="2j5mwfilo7t33">
                  Para aprender jugando
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 text-center shadow-sm sm:p-4" data-id="element-274" data-mp="2a4yj6q43pwr9">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F1F5FB] text-lg sm:h-12 sm:w-12 sm:text-2xl" aria-hidden="true" data-id="element-275" data-mp="209wt9s204qnm">
                📄
              </span>
              <div data-id="element-276" data-mp="1vldu43dwrbjz">
                <h4 className="font-display text-[9px] font-black leading-tight text-[#1C3587] sm:text-[12px]" data-id="element-277" data-mp="1vlxcfl7h01yj">
                  Material descargable
                </h4>
                <p className="mt-0.5 text-[7px] font-bold leading-tight text-gray-500 sm:text-[9px]" data-id="element-278" data-mp="1lleoae8vhzat">
                  Listo para usar
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 text-center shadow-sm sm:p-4" data-id="element-279" data-mp="2eb3oipdrdvbd">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F1F5FB] text-lg sm:h-12 sm:w-12 sm:text-2xl" aria-hidden="true" data-id="element-280" data-mp="20hcme22cxdpo">
                🎁
              </span>
              <div data-id="element-281" data-mp="2s8iim7eyir9o">
                <h4 className="font-display text-[9px] font-black leading-tight text-[#1C3587] sm:text-[12px]" data-id="element-282" data-mp="2x1bpp1xwebox">
                  Bonos incluidos
                </h4>
                <p className="mt-0.5 text-[7px] font-bold leading-tight text-gray-500 sm:text-[9px]" data-id="element-283" data-mp="lkjm0muipopm">
                  Sin costo adicional
                </p>
              </div>
            </div>

          </div>
        </Reveal>

      </div>
    </section>;
}